import { TransformFnParams } from 'class-transformer';
import dayjs from 'dayjs';
import { DayJsUtils } from './dayjs-utils';

/**
 * Class Transformer for DayJs dates - simply parses the ISO string
 * @param params
 */
export function dayjsTransformer(
  params: TransformFnParams,
): dayjs.Dayjs | undefined {
  if (params.value) {
    return DayJsUtils.toDayjs(params.value);
  }
  return undefined;
}
